import axios from 'axios';
import config from 'config.js';

// Constants
const LOGIN_REQUEST = 'user/LOGIN_REQUEST';
const LOGIN_SUCCESS = 'user/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'user/LOGIN_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  login: { ...endpoitInitialStatus },
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === LOGIN_REQUEST) {
    state.login = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === LOGIN_SUCCESS) {
    localStorage.setItem('user_token', action.payload.token);
    window.location.reload();

    return { ...state };
  }

  if (action.type === LOGIN_FAILURE) {
    state.login = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function login(data) {
  const request = () => { return { type: LOGIN_REQUEST } };
  const success = (res) => { return { type: LOGIN_SUCCESS, payload: res } };
  const failure = () => { return { type: LOGIN_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.login(data);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  login: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/login`,
        headers: {
          'Content-Type': 'application/json'
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
